import React from "react";
import PropTypes from "prop-types";
import { Dispatcher, NavigatorAction, NavigatorStore } from "../../flux";
import { Isvg } from "../../components";
import ReadingProgress from "./reader/reading-progress";
import ReadingList from "./reader/reading-list";

export default class Header extends React.Component {
  componentWillUnmount() {
    Dispatcher.unbind(
      Dispatcher.NAVIGATOR_STATE_CHANGE,
      "assignments-header-navigation"
    );
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 1);
  }

  componentDidMount() {
    this.props.focus &&
      Fraction.Helpers.Users.getUserData("allow-cookies") &&
      this.header.focus();
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
    Dispatcher.bind(
      Dispatcher.NAVIGATOR_STATE_CHANGE,
      this.forceUpdate.bind(this),
      "assignments-header-navigation"
    );
  }

  leftButton() {
    const routeStack = NavigatorStore.get();
    if (this.props.returnUrl) {
      return (
        <a className="back noButton" href={this.props.returnUrl}>
          <Isvg src="/img/assignments/assets/img/assignments_back_arrow.svg" />
          <span className="offscreen">{i18n.t("assignments.back")}</span>
        </a>
      );
    } else if (this.props.menu) {
      const total = this.props.readings.length;
      const completed = this.props.readings.filter(r => r.completed_at).length;
      return (
        <div>
          <button
            className={`noButton`}
            onClick={this.props.menu}
            aria-expanded={!!this.props.menuOpen}
          >
            <Isvg src="/img/assignments/assets/img/assignments_hamburger.svg" />
            <span className="offscreen">{i18n.t("assignments.menu")}</span>
          </button>
          <div
            aria-hidden={!this.props.menuOpen}
            className={`reading-summary ${this.props.menuStatus(
              this.props.menuOpen
            )}`}
          >
            <div className="progress-header">
              <ReadingProgress
                size="small"
                total={total}
                completed={completed}
              />
              <span className="offScreen">
                {i18n.t("assignments.progress", { completed, total })}
              </span>
              <div className="book-header">
                <div className="assignment-title">
                  {this.props.assignment.title}
                </div>
                <hr />
                <div className="book-title">{this.props.book.title}</div>
                <div className="book-author">{this.props.book.author}</div>
              </div>
            </div>
            <div className="readings">
              <h2>{i18n.t("assignments.readings")}</h2>
              <ReadingList
                book={this.props.book}
                assignment={this.props.assignment}
                reading={this.props.reading}
                readings={this.props.readings}
                loading={this.props.loading}
                onReadingClicked={this.props.startReading}
              />
            </div>
          </div>
        </div>
      );
    } else if (!this.props.hideBackButton) {
      const show = routeStack.length > 1;
      return (
        <button
          className={`noButton ${show ? "" : "notVisible"}`}
          aria-hidden={!show}
          onClick={() => NavigatorAction.pop()}
        >
          <Isvg src="/img/assignments/assets/img/assignments_back_arrow.svg" />
          <span className="offscreen">Back</span>
        </button>
      );
    }
  }

  rightButtons() {
    const justification =
      this.props.minimize && this.props.close ? "space-between" : "flex-end";
    return (
      <div
        className="right button-container"
        style={{ justifyContent: justification }}
      >
        {this.props.minimize && (
          <button onClick={() => this.props.minimize()} className={`noButton`}>
            <Isvg src="/img/assignments/assets/img/assignments_minimize.svg" />
            <span className="offscreen">Minimize</span>
          </button>
        )}
        <button
          ref={button => {
            this.closeButton = button;
          }}
          onClick={() => {
            this.props.close();
            NavigatorAction.reset();
          }}
          className={`noButton`}
        >
          <Isvg src="/img/assignments/assets/img/assignments_x.svg" />
          <span className="offscreen">
            {i18n.t("assignments.exit-to-library")}
          </span>
        </button>
      </div>
    );
  }

  render() {
    return (
      <div
        ref={header => {
          this.header = header;
        }}
        tabIndex={-1}
        className="header assignments-header"
        aria-labelledby="title"
      >
        <div className="left button-container">{this.leftButton()}</div>
        <h1 id="title">{this.props.title}</h1>
        {this.rightButtons()}
      </div>
    );
  }
}

Header.propTypes = {
  close: PropTypes.func,
  minimize: PropTypes.func,
  menu: PropTypes.func
};

Header.defaultProps = {
  focus: true
};
